import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import '../reportStyles.scss';
import { CustomButton, CustomCheckBox } from '../../../shared/uiComponents';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { ReportFilters } from '../helpers';
import { REPORT_GENERATION_MESSAGE } from '../../../shared/Helpers/constants';
import { ELC_FUNDER_ID } from '../../../redux/API/constants';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getClientGraphs } from '../../../redux/State/exportSlice';

// ELC-scoped graph report: identical to the standard Graph report but requests the ELC funder's
// separated goal tree. The standard Graph report omits funderId and so returns only the shared
// Insurance + DOE (null) tree, keeping ELC data off it.
const ElcGraphReport = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const [includeTargets, setIncludeTargets] = useState<boolean>(true);
	const [includeBehaviors, setIncludeBehaviors] = useState<boolean>(false);

	const filterData = useSelector((state) => state.billing.billingFilters);
	const loading = useSelector((state) => state.export.loading);

	const clientId = filterData.clientId;

	const handleDownloadGraph = () => {
		const { startDate, endDate } = filterData;

		if (!clientId || !startDate || !endDate) return;

		toast(REPORT_GENERATION_MESSAGE);

		dispatch(
			getClientGraphs({
				clientId,
				startDate,
				endDate,
				includeTargets,
				includeBehaviors,
				funderId: ELC_FUNDER_ID,
			}),
		)
			.then(unwrapResult)
			.then((response) => {
				const objectURL = URL.createObjectURL(response);
				const link = document.createElement('a');
				link.href = objectURL;
				link.setAttribute('download', `ELC Graph Reports - ${startDate} - ${endDate}.pdf`);
				document.body.appendChild(link);
				link.click();
			})
			.catch(errorNormalizer);
	};

	const includeBehaviorsHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIncludeBehaviors(checked);
	};

	const includeTargetsHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIncludeTargets(checked);
	};

	return (
		<>
			<ReportFilters showUsers={false} showOnlyNew={false} clientFunderId={ELC_FUNDER_ID} />
			<div style={{ display: 'flex', maxWidth: '720px', gap: '16px' }}>
				<CustomCheckBox
					item={{
						label: 'Include Targets',
						id: '0',
						checked: includeTargets,
						disabled: loading,
					}}
					onChange={includeTargetsHandler}
				/>
				<CustomCheckBox
					item={{
						label: 'Include Behaviors',
						id: '0',
						checked: includeBehaviors,
						disabled: loading,
					}}
					onChange={includeBehaviorsHandler}
				/>
				<div style={{ width: '150px' }}>
					<CustomButton
						title="Download"
						className="marginRight16"
						loading={loading}
						onClick={handleDownloadGraph}
						disabled={!filterData.clientId || filterData.timeError}
					/>
				</div>
			</div>
		</>
	);
};

export default ElcGraphReport;
